import React from 'react';

const LoadingSpinner = ({ 
  size = 'medium', 
  text = 'Loading...', 
  showText = true,
  className = '' 
}) => {
  const getSize = () => {
    switch (size) {
      case 'small':
        return '20px';
      case 'large':
        return '50px';
      default:
        return '30px';
    }
  };

  return (
    <div 
      className={`loading-spinner ${className}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '10px',
        padding: '20px'
      }}
    >
      <div
        style={{
          width: getSize(),
          height: getSize(),
          border: '3px solid #f3f3f3',
          borderTop: '3px solid #428cb1',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}
      />
      {showText && (
        <span style={{ 
          color: '#666', 
          fontSize: '14px',
          fontWeight: '500'
        }}>
          {text}
        </span>
      )}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;




